import axios from "axios";
import { useMemo, useState } from "react";

const getDailyNFTBuyers = async () => {
    try {
        const { data } = await axios.get(
            process.env.REACT_APP_API_URL + "/marketOverview/dailynewbuyers"
        )
        return data;
    }
    catch (error) {
        return error;
    }
}

export function useNFTBuyers() {
    const [api, setAPIData] = useState<any>({
        loading: true,
        error: false,
        data: undefined
    });



    useMemo(async () => {
        const data = await getDailyNFTBuyers();
        setAPIData({
            loading: false,
            error: false,
            data: data
        })
    }, [])
    return api;
}
